<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
      <asideCom :activityIndex="4"></asideCom>
      <div class="playRecord">
        <div class="titleBox">
          <p class="title clearfix">
            {{ $t("people.历史记录")
            }}<span @click="clearPlayRecord"
              ><img
                src="https://image.manamana.net/1615974276000_XLwgzbMs"
                alt=""
              />{{ $t("people.清除历史记录") }}</span
            >
          </p>
        </div>
        <div class="videoList" v-if="playList.length">
          <div class="listBox" v-for="(item, i) in playList" :key="i">
            <p class="name">{{ getTime(item.time) }}</p>
            <div class="video clearfix" v-for="(list, y) in item.data" :key="y">
              <div class="imgBox" @click="gotoVideo(list.videoId)">
                <img :src="list.thumb | imageUrl('', '400', '224')" alt="" />
                <span>{{ list.duration | secondToDate }}</span>
              </div>
              <div class="content">
                <p class="text">
                  {{
                    language === "zh" ? list.title : list.enTitle || list.title
                  }}
                </p>
                <p class="intro">
                  {{
                    language === "zh" ? list.introduction : list.enIntroduction || list.introduction
                  }}
                </p>
                <p class="data">
                  <span class="nick" @click="gotoPeople(list.userId)">{{
                    list.nickname
                  }}</span>
                  <span class="time">{{
                    list.videoCreateTime | dateToNow(language)
                  }}</span>
                  <span class="number"
                    ><img
                      src="/static/peopleCenter/view_icon@2x.png"
                      alt=""
                    />{{ list.viewCount }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <Loading v-if="loading" />
          <Reload v-if="loadError" @callback="loadMore" />
          <no-more v-if="!hasNextPage && playList.length" />
        </div>
        <content-empty
          v-else
          :content="$t('global.没有播放记录')"
        ></content-empty>
      </div>
    </div>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import ContentEmpty from "@/components/ContentEmpty.vue";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import NoMore from "@/components/v2/NoMore";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight,
} from "@/assets/screen";
export default {
  name: "playRecord",
  metaInfo() {
    return {
      title: this.$t("people.历史记录") + " | MANA",
    };
  },
  data() {
    return {
      playList: [],
      loadError: false,
      loading: false,
      hasNextPage: false,
      pageIndex: 1,
      pagesize: 10,
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    ContentEmpty,
    Reload,
    Loading,
    NoMore,
  },
  created() {
    this.playListF();
    // this.getTime("20170830103035");
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  methods: {
    getTime(timeString) {
      let date = new Date(timeString);
      let today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      // today 为今天凌晨的时间
      let dayTime = 24 * 60 * 60 * 1000;
      let delta = today - date; // 得到相差的时间 ms
      if (delta > 0) {
        if (delta <= dayTime) {
          return "昨天";
        }
      } else if (-delta < dayTime) {
        return "今天";
      }
      return timeString;
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 120) {
        if (!this.loading && this.hasNextPage) {
          this.playListF();
        }
      }
    },
    playListF() {
      this.loading = true;
      this.$http
        .get("/api/u/relation/playList2", {
          params: {
            pageIndex: this.pageIndex,
            pagesize: this.pagesize,
          },
        })
        .then((response) => {
          if (response.code === "OK") {
            if (this.pageIndex === 1) {
              this.playList = [];
            }
            this.hasNextPage = response.data.hasNextPage;
            if (this.pageIndex >= 2) {
              if (
                this.playList[this.playList.length - 1].time ==
                response.data.list[0].time
              ) {
                this.playList[this.playList.length - 1].data = [
                  ...this.playList[this.playList.length - 1].data,
                  ...response.data.list[0].data,
                ];
                response.data.list.splice(0, 1);
              }
            }
            this.playList = [...this.playList, ...response.data.list];
            this.loading = false;
            this.loadError = false;
            this.pageIndex++;
          } else {
            this.loadError = true;
            if (this.pageIndex !== 1) {
              this.pageIndex--;
            }
          }
        });
    },
    clearPlayRecord() {
      this.$confirm(
        this.$t("global.确认清空播放记录吗"),
        this.$t("global.提示"),
        {
          confirmButtonText: this.$t("global.确定"),
          cancelButtonText: this.$t("global.取消"),
        }
      ).then(() => {
        this.$http.post("/api/u/relation/clearPlay").then((response) => {
          if (response) {
            this.pagerParam.currentPage = 1;
            this.playListF();
          }
        });
      });
    },
    gotoVideo(videoId) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + videoId,
      });
      window.open(routeData.href, "_blank");
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.playListF();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;

  .playRecord {
    width: 825px;

    .titleBox {
      padding-top: 16px;

      .title {
        height: 30px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        line-height: 30px;

        span {
          font-size: 14px;
          font-weight: 400;
          color: #3664ED;
          float: right;
          cursor: pointer;

          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }

    .videoList {
      margin-top: 20px;
      width: 825px;
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      padding: 30px 36px;
      box-sizing: border-box;

      .listBox {
        .name {
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-bottom: 20px;
        }

        .video {
          margin-bottom: 24px;

          .imgBox {
            float: left;
            width: 200px;
            height: 112px;
            position: relative;
            margin-right: 15px;
            cursor: pointer;

            img {
              width: 100%;
              height: auto;
            }

            span {
              position: absolute;
              bottom: 0;
              right: 0;
              padding: 0 6px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              background: rgba(10, 10, 10, 0.8);
              font-size: 12px;
              font-weight: 600;
              color: #FFFFFF;
            }
          }

          .content {
            float: left;
            width: 536px;

            .text {
              max-height: 44px;
              font-size: 16px;
              font-weight: 600;
              color: #0A0A0A;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
            }

            .intro {
              margin: 10px 0;
              max-height: 36px;
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              line-height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
            }

            .data {
              .nick {
                font-size: 12px;
                font-weight: 600;
                color: #666666;
                cursor: pointer;
              }

              .time {
                margin: 0 20px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
              }

              .number {
                font-size: 12px;
                font-weight: 400;
                color: #B8B8B8;

                img {
                  width: 18px;
                  height: 12px;
                  margin-bottom: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/playRecord.vue